import { BO, BusinessObjectBase, NonUniqueModelDataError, RepositoryResponseConflictCodes, ResponseConflictObject, Weaver } from '@skylab-shared/core';
import { BankAccountModel } from '@skylab-shared/dataModel';
import { sameValues } from '@skylab-shared/utils';
import { NrbUtils } from '../common/nrb-utils';
import { propertyChangedFilter } from '../common/property-changed/property-changed-filter';
import { NrbValidator } from '../common/validators/nrb-validator';
import { InvalidAccountNumberWarning } from './violations/invalid-account-number-warning';

@BO({ modelType: BankAccountModel })
export class BankAccountBO extends BusinessObjectBase<BankAccountModel> {
    public constructor(
        weaver: Weaver
    ) {
        super(weaver);
    }

    protected override async initializeAsync(): Promise<void> {
        await super.initializeAsync();

        this.registerValidationRules();
        this.registerBankNameRecognizing();
    }

    protected override handleConflictSaveResponse(conflict: ResponseConflictObject<RepositoryResponseConflictCodes>) {
        if ((conflict.code === RepositoryResponseConflictCodes.UniqueConstraintViolation)) {
            const violations: {property: string, violation: NonUniqueModelDataError}[] = [];
            if (sameValues(conflict.objectProperties!, ['name'])) {
                violations.push({
                    property: 'name',
                    violation: new NonUniqueModelDataError('business.bank-account.validation.name.server-rule-violations.non-unique-model-data-error')
                });
            }
            if (sameValues(conflict.objectProperties!, ['number'])) {
                violations.push({
                    property: 'number',
                    violation: new NonUniqueModelDataError('business.bank-account.validation.account-number.server-rule-violations.non-unique-model-data-error')
                });
            }
            this.addExternalRuleViolations({
                [this.model.sun]: violations
            });
        }
    }

    private registerValidationRules(): void {
        this.validation.addRule(
            [[BankAccountModel, 'number']],
            ctx => NrbValidator.isValid(ctx.source.number),
            InvalidAccountNumberWarning
        );
    }

    private registerBankNameRecognizing(): void {
        this.propertyChanged.listen<BankAccountModel>(propertyChangedFilter(BankAccountModel, ['number'], ({ model }) => {
            model.bankName = NrbUtils.recognizeBank(model.number);
        }));
    }
}
